import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/MainView_coach.vue')
	//component: () => import('../views/MainView.vue')
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/UsersView.vue')
  },
  {
    path: '/developer',
    name: 'developer',
    component: () => import('../views/developer/DeveloperView.vue')
  },

  {
    path: '/sessions-list',
    name: 'sessions-list',
    component: () => import('../views/session/ListSessionsView.vue')
  },
  {
    path: '/session/:sessionId',
    name: 'session',
    component: () => import('../views/MainView_coach.vue')
	//component: () => import('../views/MainView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 